import Carousel1 from "../images/Carousel_1.png";
import Carousel2 from "../images/Carousel_2.png";
import Carousel3 from "../images/Carousel_3.png";
import Carousel4 from "../images/Carousel_4.png";

export const SELECTION_ITEMS = [
	{ id: 1, name: "Data" },
	{ id: 2, name: "Category Name" },
	{ id: 3, name: "Category Name" },
];

export const MENU_ITEMS = [
	{ id: 1, name: "Menu Item" },
	{ id: 2, name: "Menu Item" },
	{ id: 3, name: "Menu Item" },
	{ id: 4, name: "Menu Item" },
	{ id: 5, name: "Menu Item" },
	{ id: 6, name: "Menu Item" },
	{ id: 7, name: "Menu Item" },
	{ id: 8, name: "Menu Item" },
	{ id: 9, name: "Menu Item" },
	{ id: 10, name: "Menu Item" },
	{ id: 11, name: "Menu Item" },
	{ id: 12, name: "Menu Item" },
];

export const SUB_MENU_ITEMS = [
	{
		id: 1, name: "Header",
		subtitles: [
			{ id: 1, name: "Subheader" },
			{ id: 2, name: "Subheader" },
			{ id: 3, name: "Subheader" },
			{ id: 4, name: "Subheader" },
			{ id: 5, name: "Subheader" },
			{ id: 6, name: "Subheader" },
			{ id: 7, name: "Subheader" },
			{ id: 8, name: "Subheader" },
		]
	},
	{
		id: 2, name: "Header",
		subtitles: [
			{ id: 9, name: "Subheader" },
			{ id: 10, name: "Subheader" },
			{ id: 11, name: "Subheader" },
			{ id: 12, name: "Subheader" },
			{ id: 13, name: "Subheader" },
			{ id: 14, name: "Subheader" },
			{ id: 15, name: "Subheader" },
			{ id: 16, name: "Subheader" },
		]
	}
];

export const CAROUSEL_IMAGES = [{ id: 1, image: Carousel1 }, { id: 2, image: Carousel2 }, { id: 3, image: Carousel3 }, { id: 4, image: Carousel4 }];

export const FOOTER_SUBTITLES = [
	{
		id: 1, name: "Title",
		subtitles: [
			{ id: 1, name: "Subtitle" },
			{ id: 2, name: "Subtitle" },
			{ id: 3, name: "Subtitle" },
			{ id: 4, name: "Subtitle" },
		]
	},
	{
		id: 2, name: "Title",
		subtitles: [
			{ id: 5, name: "Subtitle" },
			{ id: 6, name: "Subtitle" },
			{ id: 7, name: "Subtitle" },
			{ id: 8, name: "Subtitle" },
		]
	},
	{
		id: 3, name: "Title",
		subtitles: [
			{ id: 9, name: "Subtitle" },
			{ id: 10, name: "Subtitle" },
			{ id: 11, name: "Subtitle" },
			{ id: 12, name: "Subtitle" },
		]
	},

];